import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationRoutingService } from '@application-routing';
import { AppState } from '@appStates';
import { ELocationPageState, ListLazyComponents } from '@enums';
import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { selectSingleAdviceTipState } from 'src/app/store/selectors/start.page.selectors';
import { getPrevRouteState } from 'src/app/store/selectors/navigate.selectors';
import { PrivatePageExceptionReturnBtn } from '../../../store/actions';
import { privateIsFromHomePage, privatePageStateCurrentBlock, selectorExceptionPrivatePageReturnBtn } from '../../../store/selectors/private-page.selectors';

@Component({
  selector: 'bz-return-btn-arrow',
  templateUrl: './return-btn-arrow.component.html',
  styleUrls: ['./return-btn-arrow.component.sass']
})
export class ReturnBtnArrowComponent {
  @Input() public easyBack: boolean = false;
  @Input() public isPrivateMenu: boolean = false;
  @Input() public isPharmcyListMobile: boolean = false;
  @Input() public isLocationState: ELocationPageState = ELocationPageState.address;
  @Output() public pushBtnReturn: EventEmitter<any> = new EventEmitter();

  constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly applicationRoutingService: ApplicationRoutingService
  ) { }

  public switchOn(): void {
    if (this.isOutsideEvent(this.router.routerState.snapshot.url)) {
      this.pushBtnReturn.emit();
      return;
    }

    let exception: string;
    this.store.pipe(select(selectorExceptionPrivatePageReturnBtn), take(1)).subscribe(e => exception = e);
    if (exception) {
      if (this.isLocationState === 0) {
        this.applicationRoutingService.navigate(null, exception);
        this.store.dispatch(PrivatePageExceptionReturnBtn({ exception: null }));
        if (exception.includes('pharmacies')) { return; }
      }
    }

    let prevPharmaciesPageUrl: string = this.getPharmaciesPagePrevUrl();
    if (prevPharmaciesPageUrl && this.isLocationState === 0) {
      this.router.navigateByUrl(prevPharmaciesPageUrl);
      return;
    }

    let advice: boolean;
    this.store.pipe(select(selectSingleAdviceTipState), take(1)).subscribe((state: boolean) => advice = state);
    if (advice) {
      this.pushBtnReturn.next(null);
      return;
    }

    if (!this.easyBack && !this.isPrivateMenu) {
      this.applicationRoutingService.navigate(null, this.router.routerState.snapshot.url);
    } else if (this.isPrivateMenu) {
      let routFromHomePage: boolean;
      this.store.pipe(select(privateIsFromHomePage), take(1)).subscribe(state => routFromHomePage = state);
      if (routFromHomePage) {
        this.applicationRoutingService.navigate(null, this.router.routerState.snapshot.url);
      } else {
        let currentBlock: number;
        this.store.pipe(select(privatePageStateCurrentBlock), take(1)).subscribe(data => currentBlock = data);
        if (currentBlock === 4) {
          if (this.isLocationState === 1) {
            this.pushBtnReturn.next(null);
          } else {
            this.applicationRoutingService.navigate(ListLazyComponents.menu, this.router.routerState.snapshot.url);
          }
        } else {
          this.applicationRoutingService.navigate(ListLazyComponents.menu, this.router.routerState.snapshot.url);
        }
      }
    } else if (!this.isPharmcyListMobile) {
      this.applicationRoutingService.returnPrevPageMobile();
    } else if (this.isPharmcyListMobile) {
      this.pushBtnReturn.next(null);
    }

  }

  public isOutsideEvent(url: string): boolean {
    const set: string[] = ['/info-drug/', '/catalog'];
    return set.some((item: string) => url.includes(item));
  }

  private getPharmaciesPagePrevUrl(): string {
    let previous: string;
    this.store.pipe(
      select(getPrevRouteState),
      filter(value => !!value),
      take(1)
    ).subscribe((prev) => {
      if (prev.url && prev.url.includes('pharmacies')) {
        previous = prev.url;
      }
    });
    return previous;
  }

}
